module.exports = __webpack_public_path__ + "img/pause.1bca988.jpg";